module.exports = __webpack_public_path__ + "static/media/singapore.d172d274.svg";